module.exports = __webpack_public_path__ + "electronics.c7502728ad184d841e15.ttf";


//////////////////
// WEBPACK FOOTER
// C:/Users/INMOGR/Desktop/Angular Project/src/assets/fonts/line-icons-pro/electronics/webfont/electronics.ttf
// module id = ../../../../../src/assets/fonts/line-icons-pro/electronics/webfont/electronics.ttf
// module chunks = styles